import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  OnyxDatePipe,
  OnyxIconComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../common/enums/dictionary-code';
import { CommonHelper } from '../../../../common/helpers/common.helper';
import { RouteHelper } from '../../../../common/helpers/route.helper';
import { OrderMissingAssignmentType } from '../../common/enums/order-missing-assignment-type';
import { OrderHelper } from '../../common/helpers/order.helper';
import type { Order } from '../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-deadline-message',
  imports: [
    OnyxIconComponent,
    OnyxDatePipe,
    TranslatePipe,
    OnyxTooltipDirective,
  ],
  templateUrl: './order-modal-deadline-message.component.html',
  styleUrl: './order-modal-deadline-message.component.scss',
})
export class OrderModalDeadlineMessageComponent {
  private readonly translateService = inject(TranslateService);
  private readonly commonHelper = inject(CommonHelper);

  public readonly order = input.required<Order>();

  protected readonly I18N = 'orders.orderModal';

  protected readonly CommonHelper = CommonHelper;

  protected currentPoint = computed(() =>
    OrderHelper.getCurrentPoint(this.order().points),
  );
  protected pointData = computed(() =>
    RouteHelper.getPointRouteData(
      this.currentPoint(),
      this.order().points,
      this.commonHelper.nowMinute(),
    ),
  );
  protected missingAssignment = computed(() =>
    OrderHelper.getMissingAssignment(this.order()),
  );
  protected deadlineSubheading = computed(() => {
    const point = this.currentPoint();
    if (!point) return null;

    const missingAssignment = this.missingAssignment();
    if (missingAssignment) {
      const labelMap: Partial<Record<OrderMissingAssignmentType, string>> = {
        [OrderMissingAssignmentType.LOADED_TRAILER_WITHOUT_VEHICLE]:
          'labels.semiTrailerPickup',
        [OrderMissingAssignmentType.GOODS_WITHOUT_VEHICLE]:
          'labels.goodsPickup',
      };

      return labelMap[missingAssignment.type];
    }

    const type = this.translateService.instant(
      `${DictionaryCode.ORDER_POINT_TYPE}.${point.type}`,
    );
    const to = this.translateService.instant('labels.to');

    return `${type} ${to.toLowerCase()}`;
  });
}
